import { css } from '@emotion/react';
import { type FC } from 'react';
import { EmbeddedYouTubeVideoComponent } from '~/_shared/baseComponents/embededYoutubeVideo/embeddedYouTubeVideo';
import { MAPTIVE_OVERVIEW_YOUTUBE_ID } from '~/_shared/baseComponents/embededYoutubeVideo/youtubeVideoIds.constants';
import { Stack } from '~/_shared/baseComponents/layout/Stack.componment';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { type ModalProps } from '~/modal/modalType.enum';

const paragraphStyles = css({
  margin: 0,
});

type WalkthroughModalProps = ModalProps;

export const WalkthroughModalComponent: FC<WalkthroughModalProps> = ({
  onClose,
  isOpen,
}) => {
  const [t] = useTranslation();

  return (
    <ModalComponent
      caption={t('walkthroughModal.caption')}
      isOpen={isOpen}
      onClose={onClose}
      skipCloseOnMapIdChange
      preventCloseOnOverlayClick
    >
      <Stack
        gap={16}
      >
        <p css={paragraphStyles}>
          {t('walkthroughModal.paragraph.text')}
        </p>
        <EmbeddedYouTubeVideoComponent
          videoId={MAPTIVE_OVERVIEW_YOUTUBE_ID}
          title={t('walkthroughModal.video.title')}
        />
      </Stack>
    </ModalComponent>
  );
};
